import { getTopImage } from '../getTopImage';
import {
    ContactKosovoPageDocument,
    ContactKosovoPageQuery,
} from '../gql-types';
import { gqlClient } from '../gqlClient';

export async function loadContactKosovoPageContent(locale: string) {
    const { data } = await gqlClient.query<ContactKosovoPageQuery>(
        ContactKosovoPageDocument,
        { lang: locale },
    ).toPromise();
    return {
        topImage: getTopImage(data?.contact_kosovo?.top_image),
        content: data?.contact_kosovo?.translations?.[0]?.content ?? '',
    };
}
